import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistrySingleView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

/**
 * Component IDs in the portfolio page registry.
 */
enum PortfolioTabPageRegistryComponentId {
    CnesstForms
}

/**
 * Props for the portfolio page registry.
 */
interface IPortfolioTabPageRegistryProps {
    componentId: PortfolioTabPageRegistryComponentId;
}

/**
 * Registry for the portfolio page components.
 */
class PortfolioTabPageRegistry extends BaseComponentRegistry<PortfolioTabPageRegistryComponentId, IPortfolioTabPageRegistryProps> {}

/**
 * React component for the portfolio page registry.
 */
const PortfolioTabPageRegistryView = createRegistrySingleView(() => PortfolioTabPageRegistry.getInstance());

export {
    IPortfolioTabPageRegistryProps,
    PortfolioTabPageRegistry,
    PortfolioTabPageRegistryComponentId,
    PortfolioTabPageRegistryView
};
